import React, {
    useCallback,
    useMemo,
    useContext
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { WizardPage } from 'gw-portals-wizard-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { useTranslator, FormattedMessage } from '@jutro/locale';
import AdacDigitalWizardPageTemplate from '../../templates/AdacDigitalWizardPageTemplate';
import FNOLContext from '../../components/Context/Context';
import styles from './LandingPage.module.scss';
import metadata from './LandingPage.metadata.json5';
import wizardMessages from '../../FNOLAdacWizard.messages';
import messages from './LandingPage.messages';
import wizardConfig from '../../config/fnol-adac-wizard-config.json5';
import ACTION_OPTIONS from '../../constants/FnolActionOptions';

function LandingPage(props) {
    const { changeNextSteps, currentStepIndex } = props;
    const translator = useTranslator();
    const { steps: wizardSteps } = wizardConfig;
    const {
        actionOption,
        agreementConsent,
        setActionOption,
        setAgreementConsent
    } = useContext(FNOLContext);

    const overrides = {
        radiobuttoncard: {
            value: actionOption
        },
        agreementText: {
            content: <FormattedMessage
                {...messages.furtherStepsConsent}
                values={{
                    dataProtection: (
                        <a
                            className={styles.link}
                            href={translator(messages.dataProtectionLink)}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {`${translator(messages.dataProtection)}`}
                        </a>
                    ),
                    termsOfUse: (
                        <a
                            className={styles.link}
                            href={translator(messages.termsOfUseLink)}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {`${translator(messages.termsOfUse)}`}
                        </a>
                    )
                }}
            />
        },
        agreement: {
            value: agreementConsent
        }
    };

    const handleOptionSelect = useCallback((value) => {
        setActionOption(value);
    }, [setActionOption]);

    const handleAgreementSelect = useCallback((value) => {
        setAgreementConsent(value);
    }, [setAgreementConsent]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            handleOptionSelect,
            handleAgreementSelect
        }
    };

    const onNext = useCallback(() => {
        let nextSteps = wizardSteps.slice(currentStepIndex + 1, wizardSteps.length);
        if (actionOption !== ACTION_OPTIONS.option1) {
            nextSteps = nextSteps.filter((step) => step.path !== '/incident-type');
        }
        changeNextSteps(nextSteps);
    }, [actionOption, changeNextSteps, currentStepIndex, wizardSteps]);

    const isValid = useMemo(() => {
        return !_.isNil(actionOption) && agreementConsent;
    }, [actionOption, agreementConsent]);

    return (
        <WizardPage
            onNext={onNext}
            showCancel={false}
            showPrevious={false}
            nextLabel={wizardMessages.next}
            disableNext={!isValid}
            template={AdacDigitalWizardPageTemplate}
            hideWizardSteps
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                overrideProps={overrides}
            />
        </WizardPage>
    );
}

export default withRouter(LandingPage);
